<template>
  <div class="logo">Human Tech Design</div>
</template>
<script>
export default {
  name: "Logo"
};
</script>
<style scoped>
.logo {
  position: relative;
  text-indent: -3000px;
  pointer-events: none;
  width: 56px;
  height: calc(var(--LINE-HEIGHT) * 2);
  color: var(--BLACK);
}

.logo::before {
  content: " ";
  width: 25.3px;
  height: 25.3px;
  position: absolute;
  background-color: currentColor;
  top: calc(var(--LINE-HEIGHT) - (25.3px / 2));
  border-radius: 100%;
  left: 0;
}
.logo::after {
  content: " ";
  width: 19.6px;
  height: 19.6px;
  position: absolute;
  background-color: currentColor;
  top: calc(var(--LINE-HEIGHT) - (19.6px / 2));
  left: 33px;
  transform: rotate(45deg);
}

@media only screen and (max-width: 576px) {
  .logo {
    width: 46px;
  }
  .logo::before {
    width: 21.2px;
    height: 21.2px;
    top: calc(var(--LINE-HEIGHT) - (21.2px / 2));
  }
  .logo::after {
    width: 16.6px;
    height: 16.6px;
    left: 27.88px;
    top: calc(var(--LINE-HEIGHT) - (16.6px / 2));
  }
}
/*
@media only screen and (min-width: 576px) and (max-width: 767px) {}
@media only screen and (min-width: 768px) and (max-width: 992px) {}
@media only screen and (min-width: 992px) {}
*/
</style>


// WEBPACK FOOTER //
// src/components/Logo.vue